// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'es6-promise/auto'
import 'babel-polyfill'
import Vue from 'vue'
import router from '@/router'
import App from './App'
import store from '@/store'
import Howl from 'howler';
import VueYoutubeEmbed, { YouTubePlayer as Youtube } from 'vue-youtube-embed'
Vue.use(VueYoutubeEmbed, { global: false })
Vue.config.productionTip = false

// Make NPO tracker available in Vue components
Vue.prototype.$tracker = () => window.tracker
Vue.prototype.$smarttag = window.smarttag

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	template: '<App/>',
	components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js